/**
 * Templates Index Route
 *
 * Path: /_authenticated/templates/
 * Renders the gallery (TemplatesPage). Sibling of templates.new.tsx and
 * templates.$templateId.tsx; all three live under the templates.tsx layout.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '../../pages/Templates/TemplatesPage';

const TemplatesIndexRouteComponent = () => {
  return <TemplatesPage />;
};

export const Route = createFileRoute('/_authenticated/templates/')({
  component: TemplatesIndexRouteComponent,
});
